import Typography from '../components/Typography';
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import theme from "../../theme";
import {Theme} from "@mui/material/styles";
import {SxProps} from "@mui/system";
import HandymanIcon from '@mui/icons-material/Handyman';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import {HourglassTop} from "@mui/icons-material";

const item: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    px: 2,
    textAlign: 'center'
};

export default function ProductFeatures() {
    return (
        <Box
            component={"section"}
            sx={{ display: 'flex', overflow: 'hidden', bgcolor: theme.palette.common.white }}
        >
            <Container sx={{ mt: 15, mb: 30, display: 'flex', position: 'relative' }}>
                <Grid container spacing={5}>

                    <Grid item xs={12} md={4}>
                        <Box sx={item}>
                            <HourglassTop sx={{ fontSize: 64 }} />
                            <Typography variant="h6" sx={{ my: 5 }}>
                                {'Complex assemblies done before programs load.'}
                            </Typography>
                            <Typography variant="h5">
                                {'We use quantum manufacturing techniques.'}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Box sx={item}>
                            <HandymanIcon sx={{ fontSize: 64 }} />
                            <Typography variant="h6" sx={{ my: 5 }}>
                                {'We\'ve never broken a screw tap. Ever.'}
                            </Typography>
                            <Typography variant="h5">
                                {'We go full speed with our impact drills.'}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Box sx={item}>
                            <PrecisionManufacturingIcon sx={{ fontSize: 64 }} />
                            <Typography variant="h6" sx={{ my: 5 }}>
                                {'CNCs at Max RPM'}
                            </Typography>
                            <Typography variant="h5">
                                {'Our CNCs run at 100% speed, 24/7/365.'}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
